import React, { Component } from 'react';
import Select from 'react-select';
import { ToggleSmall, Modal } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { Breadcrumb, Card } from '../../../../components';

import { 
  insertDmService,
  getDmService,
  getByDmService,
  updateDmService,
  deleteDmService,
} from '../../../../services/Api';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      name: '',
      labelForm: 'Nome do material',
      placeForm: 'Digite aqui o nome do material',
      openMdDelete: false,
      selectedItemType: null,
      listGroups: []
    };
  }

  componentWillMount = async () => {
   await this.getGroups()
   await this.getItem();
  }

  getItem = async () => {
    const { match } = this.props;
    const urlId = match.params && match.params.id;
    const result = await getByDmService('/Material', urlId);
    console.log(result);
    const { ativo, nome, grupo } = result;
    this.setState({
      active: ativo,
      name: nome,
      selectedItemType: { id: grupo.id, label: grupo.nome },
    });
  };

  getGroups = async () => {
    const groups = await getDmService('/ProdutoCategoria/GetByTipo/?tipo=1');
    const groupsSelects = [];
    const arrayLabels = [];
    groups.forEach(group => {
      if (arrayLabels.indexOf(group.nome) === -1) {
        groupsSelects.push({ id: group.id, label: group.nome });
        arrayLabels.push(group.nome);
      }
    });

    this.setState({
      listGroups: groupsSelects,
    });
  };

  onToogle = () => {
    const { match } = this.props;
    const { active } = this.state;
    // const urlId = match.params && match.params.id;
    this.setState(
      prevState => ({
        active: !prevState.active,
      }),
      async () => {
        try {
          await updateDmService('Material/AlteraStatus', match.params.id, null);
        } catch (e) {
          this.setState({ active });
          toast.warn('Ocorreu uma falha ao tentar trocar o status do item');
        }
      },
    );
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  saveMaterial = async e => {
    e.preventDefault();
    const { name, selectedItemType } = this.state;
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;
    const urlEdit = `/Material/`;

    const formData = {
      grupo: { id: selectedItemType.id },
      nome: name,
    };

    try {
      if (urlId) {
        await updateDmService(urlEdit, urlId, formData);
        history.goBack();
        toast.success('Edição realizada com sucesso.');
      } else {
        await insertDmService(urlEdit, formData);
        history.goBack();
        toast.success('Item salvo com sucesso.');
      }
    } catch (error) {
      toast.warn('Desculpe-nos. Ocorreu alguma falha ao tentar salvar os dados');
    }
  };

  modalDelete = () => {
    this.setState(prevState => ({
      openMdDelete: !prevState.openMdDelete,
    }));
  };

  delete = async () => {
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;

    try {
      await deleteDmService('/Material', urlId);
      toast.success('Deletado conforme o solicitado.');
      history.goBack();
    } catch (error) {
      toast.error('Um erro inesperado ocorreu ao tentar deletar');
    }
  };

  onChangeGroup = event => {
    this.setState({
      selectedItemType: { id: event.id, label: event.label },
    });
  };


  render() {
    const { 
        active,
        name,
        labelForm,
        placeForm,
        openMdDelete,
        listGroups,
        selectedItemType
    } = this.state;

    const { history, match } = this.props;
    const urlId = match.params && match.params.id;
    const titleBread = 'Editar material';
    return (
      <div>
        {urlId ? (
          <Breadcrumb
            title={titleBread}
            description="Gerencie grupos de produtos agência."
            renderRight={(() => (
              <div className="flex v-sm-margin">
                <label
                  htmlFor="toogle-active"
                  className={`${active ? 'text-info ' : 'text-warning'} label-toogle-active`}
                >
                  {active ? 'Ativo' : 'Inativo'}
                </label>
                <ToggleSmall
                  id="toogle-active"
                  className="toogle-active"
                  toggled={active}
                  ariaLabel="Ativo"
                  onClick={() => this.onToogle()}
                />
                <button
                  className="bx--btn btn-primary-outlined h-sm-margin"
                  type="button"
                  onClick={() => this.modalDelete()}
                >
                  Remover
                </button>
              </div>
            ))()}
            renderLeft={(() => (
              <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        ) : (
          <Breadcrumb
            title={titleBread}
            description="Gerencie grupos de produtos agência."
            renderLeft={(() => (
              <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        )}

        <Card className="center-box">
          <form onSubmit={this.saveMaterial}>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Selecione o grupo</label>
                <Select
                  className="search-dm"
                  name="grupos"
                  options={listGroups}
                  required
                  value={selectedItemType}
                  onChange={e => this.onChangeGroup(e)}
                  placeholder="Selecione o grupo"
                  isClearable={false}
                  isSearchable
                />
              </div>
            </div>          
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label v-md-margin">{labelForm}</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder={placeForm}
                  name="name"
                  value={name}
                  onChange={this.onChangeText}
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 v-md-margin ">
                <button tabIndex="0" className="bx--btn btn-secondary-color" type="submit">
                  Salvar
                </button>
                <button
                  tabIndex="0"
                  className="h-sm-margin bx--btn btn-secondary-outlined"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </Card>

        <Modal
          className="some-class"
          open={openMdDelete}
          modalHeading="Remover Item"
          primaryButtonText="Tenho certeza"
          secondaryButtonText="Cancelar"
          iconDescription="Cancelar e fechar"
          onRequestClose={() => this.modalDelete()}
          onRequestSubmit={() => this.delete()}
        >
          <p className="bx--modal-content__text">Você tem certeza que deseja deletar este item?</p>
        </Modal>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/MaterialsManagement/Edit.js